import React from 'react';
import styles from './VersionTemplate.styl';

export default VersionTemplate

function VersionTemplate({version}) {
	return <div className={styles.versionWrap}>v{version}</div>
}



// WEBPACK FOOTER //
// ./src/react/ui/features/VersionTemplate/VersionTemplate.jsx